export default __webpack_public_path__ + "static/media/mail-lightblue.51156328.svg";